export const FILE_SIZE = 1073741824;